import { ArchivedSection } from "./ArchivedSection";
import { SettingsPageContainer } from "./settingsLayout";

export function ArchivedSettings() {
  return (
    <SettingsPageContainer>
      <ArchivedSection />
    </SettingsPageContainer>
  );
}
